import { memo, useContext } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { MediaOrientation } from '@/enums';
import icontrinity from '@/static/logos/logo-trinity-icon.svg?url';
import horizonaltrinity from '@/static/logos/logo-trinity.svg?url';
import { cx } from '@trinity/chat-components';
import { useNavbarLogo } from './hooks/useNavbarLogo';
import styles from './style/Logo.module.css';

type SquareProps = {
  size: number;
} & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

type LandscapeProps = {
  className?: string;
};

export const Responsive = (props: unknown) => {

  const classes = {
    lg: styles.lg,
    sm: styles.sm,
  };

  return (
    <div className={styles.responsive}>
      <IconTrinity
        className={classes.sm}
        size={32} />
      <HorizontalNavLogo className={classes.lg} />
    </div>
  );
};

Responsive.displayName = 'Branding.Logo.Responsive';

export const HorizontalNavLogo = memo((props: LandscapeProps) => {
  const ctx = useContext(AppThemingContext);

  const whitelabel = useNavbarLogo({
    horizontal: ctx?.query?.data?.logo?.horizontal,
    square: ctx?.query?.data?.logo?.square,
  });
  const classes = cx(styles.root, styles.landscape, props.className);

  if (ctx?.query?.data?.enabled && whitelabel?.url) {
    return (
      <div className={cx(classes, { [styles.horizontal]: whitelabel.orientation === MediaOrientation.Horizontal })}>
        <img
          className={classes}
          draggable={false}
          src={whitelabel.url} />
      </div>
    );
  }

  if (ctx?.query?.data?.enabled === false) {
    return (
      <div className={cx(classes, styles.trinity)}>
        <img
          className={classes}
          draggable={false}
          src={horizonaltrinity} />
      </div>
    );
  }

  return (
    <Skeleton
      sx={{
        borderRadius: '10px',
        opacity: 0.8,
      }}
      animation="wave"
      height={40}
      variant="rectangular"
      width={165} />
  );
});

HorizontalNavLogo.displayName = 'Branding.Logo.Horizonal.Trinity';

const IconTrinity = memo(({ size, ...props }: SquareProps) => {
  return (
    <img
      {...props}
      src={icontrinity}
      style={{ width: size, height: size }} />
  );
});

IconTrinity.displayName = 'Branding.Logo.Icon.Trinity';